import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class MenuFavoriteService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('MenuFavorite');
	}
	save(pageName: string): Observable<ECI.Basic.ReadOnlyObjectBase> {
		return this.myBaseService.post(pageName, this.url);
	}
	deleteItem(pageName: string): Observable<boolean> {
		return this.myBaseService.deleteItem(pageName, this.url);
	}

}
